export const ComboboxDataTestid = {
  CONTROLS_WRAPPER: 'combobox-controls-wrapper',
  CONTAINER: 'combobox-container',
  INPUT: 'combobox-input',
  LIST: 'combobox-menu-list',
  NO_MATCHES_FOUND: 'combobox-no-matches-found',
  SELECTED_VALUES: 'combobox-selected-values',
  DROPDOWN: 'combobox-dropdown-btn',
  OPTION: 'combobox-option',
  ALLY_SELECTED_VALUES: 'combobox-ally-selected-values',
};
